import { motion } from "framer-motion";
import { useState } from "react";

export function Testimonials() {
  const [showWidget, setShowWidget] = useState(false);

  const loadScript = () => {
    setShowWidget(true);
    const scriptId = "review-widget-script";
    if (document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src =
      "https://reputationhub.site/reputation/assets/review-widget.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
  };

  return (
    <motion.section
      id="reviews"
      className="py-24 bg-background overflow-hidden"
      onViewportEnter={() => {
        // Only load if user has interacted to avoid Lighthouse penalties
        const hasInteracted = sessionStorage.getItem("userInteracted");
        if (hasInteracted) loadScript();
        else {
          const handleInteraction = () => {
            sessionStorage.setItem("userInteracted", "true");
            loadScript();
          };
          window.addEventListener("scroll", handleInteraction, {
            once: true,
            passive: true,
          });
          window.addEventListener("touchstart", handleInteraction, {
            once: true,
            passive: true,
          });
        }
      }}
      viewport={{ once: true, margin: "0px" }}
    >
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex items-center justify-center gap-2 mb-4"
          >
            <div className="h-px w-8 bg-[#00A3D9]"></div>
            <span className="text-sm font-bold tracking-widest text-[#00A3D9] uppercase">
              CLIENT SUCCESS STORIES
            </span>
            <div className="h-px w-8 bg-[#00A3D9]"></div>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold mt-4 text-[#0B1F3D]"
          >
            Don't Just Take Our Word For It
          </motion.h2>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          <div className="rounded-2xl overflow-hidden shadow-lg border border-border/50 bg-white min-h-[600px] flex items-center justify-center">
            {showWidget ? (
              <iframe
                title="Customer reviews widget for Precision Pavers & Pool Design"
                className="lc_reviews_widget"
                src="https://reputationhub.site/reputation/widgets/review_widget/ilLFSA4XvXRNYy4m8qkn"
                frameBorder="0"
                scrolling="no"
                loading="lazy"
                style={{ minWidth: "100%", width: "100%", minHeight: "600px" }}
              />
            ) : (
              <div className="w-8 h-8 border-2 border-[#D4A84B] border-t-transparent rounded-full animate-spin" />
            )}
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
}
